<script setup>
import { BModal,BFormInput,BRow,BCol, BFormTextarea,BButton, BFormSelect } from 'bootstrap-vue-next'
import { defineModel, defineProps, ref, reactive, inject, computed, onMounted } from 'vue'
import router from '@/router';

const checked=defineModel()

const props = defineProps({
    data: Object
})

const postData = reactive({
    room_uuid : props.data.item.uuid,
    name : '',
    maintenance_type : 'null',
    start : '',
    end : '',
    days : '',
    description : '',
})

const repositories = inject('repositories');
const setMaintenanceRepository = repositories ? repositories.maintenance : null;
const maintenanceIssueRepository = repositories ? repositories.maintenanceIssue : null;


const calculateDays = computed(() => {

    if (postData.start && postData.end) {
    const startDate = new Date(postData.start);
    const endDate = new Date(postData.end);

    const timeDifference = endDate - startDate;

    const daysDifference = timeDifference / (1000 * 3600 * 24);

    return daysDifference > 0 ? daysDifference : 0;
    }
    return 0;
});

const optionMaintenanceType = ref([
{value: null, text: 'Please select an option'},
])

// Ambil data maintenance issu untuk field dropdown maintenance type
const getMaintenanceIssue = async () => {
    try{
        const response = await maintenanceIssueRepository.getAll()
        optionMaintenanceType.value = response.data.data.map(item => ({
            value: item.uuid,
            text: item.name,
        }))
        optionMaintenanceType.value.unshift({ value: null, text: 'Please select an option' })
    }catch(e){
        console.log(e)
    }
}

const setMaintenance = async ()=>{
    postData.days = calculateDays
    postData.description = postData.description === null ? '-' : postData.description
    try{
        await setMaintenanceRepository.create(postData)
        router.go(0)
    }catch(e){
        console.log(e)
    }
}

onMounted(()=>{
    getMaintenanceIssue()
})


</script>

<template>
<BModal v-model="checked" :title="props.data.item.code" no-close-on-backdrop >
    <BRow class="form-group">
        <BCol>
            <BFormInput v-model="postData.name" placeholder="Technician Name"></BFormInput>
        </BCol>
    </BRow>
    <BRow class="form-group">
        <BCol>
            <!-- <BFormInput v-model="postData.maintenance_type" placeholder="Maintenance Type"></BFormInput> -->
            <BFormSelect v-model="postData.maintenance_type" :options="optionMaintenanceType"></BFormSelect>
        </BCol>
    </BRow>
    <BRow>
        <BCol>
            <div class="form-group">
            <label for="">Start Date</label>
            <BFormInput type="date" v-model="postData.start">
                
            </BFormInput>
            </div>
        </BCol>
        <BCol>
            <div class="form-group">
            <label for="">End Date</label>
            <BFormInput type="date" v-model="postData.end">
        
            </BFormInput>
            </div>
        </BCol>
    </BRow>
    <BRow class="form-group">
        <BCol>
            <BFormTextarea v-model="postData.description" placeholder="Remark"></BFormTextarea>
        </BCol>
    </BRow>
    <template #footer>
      <div class="d-flex justify-content-end">
        <BButton variant="primary" @click="setMaintenance()" class="mr-2">Save</BButton>
        <BButton variant="danger" @click="checked = false">Cancel</BButton>
      </div>
    </template>
</BModal>

</template>